import { Matrix4, Quaternion, Vector3 } from 'three'

/** Blender's one-second rigid walk, sampled without an AnimationMixer per soldier. */
export class RigidWalk {
  private readonly frames: Array<{ position: Vector3; rotation: Quaternion }> = []
  private readonly position = new Vector3()
  private readonly rotation = new Quaternion()

  constructor(matrices: readonly (readonly number[])[]) {
    const matrix = new Matrix4()
    const scale = new Vector3()
    for (const values of matrices) {
      const position = new Vector3(), rotation = new Quaternion()
      matrix.fromArray(values).decompose(position, rotation, scale)
      this.frames.push({ position, rotation })
    }
  }

  sample(seconds: number, target: Matrix4): Matrix4 {
    const frame = ((seconds % 1 + 1) % 1) * (this.frames.length - 1)
    const index = Math.floor(frame), fraction = frame - index
    const a = this.frames[index], b = this.frames[index + 1]
    this.position.lerpVectors(a.position, b.position, fraction)
    this.rotation.slerpQuaternions(a.rotation, b.rotation, fraction)
    return target.makeRotationFromQuaternion(this.rotation).setPosition(this.position)
  }
}
